// extracted by mini-css-extract-plugin
export default {"switch":"TogglerButton_switch__B75bP","switch-input":"TogglerButton_switch-input__-dC-j","slider":"TogglerButton_slider__AuPRX","slider-round":"TogglerButton_slider-round__wROQ0"};